<script setup>
import {computed, ref, watch} from "vue";
import { useI18n } from "vue-i18n";
import dashboardService from "@/service/dashboardService";

const { t } = useI18n();
const props = defineProps(['options', 'selectedOption']);

const emit = defineEmits(['update:selectedValue']);

const dropdownVisible = ref(false);

const handleChange = (value) => {
  emit('update:selectedValue', value);
  dropdownVisible.value = false;
};

const handleClickOutside = () => {
  dropdownVisible.value = false;
};

const toggleDropdown = () => {
  dropdownVisible.value = !dropdownVisible.value;
};

const findSelected = (val) => {
  const option = props.options.find(item => item.value === val);
  return option ? option.text : '';
};
</script>

<template>
  <div class="select-box-wrapper no-text-select" v-click-outside="handleClickOutside">
    <div class="select-custom" @click="toggleDropdown">
      <span class="select-selected">{{ findSelected(props.selectedOption) }}</span>
      <img src="@/assets/images/arrowdown.svg" />
    </div>

    <div class="select-custom-content align-right" v-if="dropdownVisible">
      <div
          class="select-custom-item"
          v-for="option in props.options"
          :key="option.value"
          :class="option.value === props.selectedOption && 'selected'"
          @click="handleChange(option.value)"
      >
        {{ option.text }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.select-box-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.select-custom {
  border-radius: 10px;
  border: 1px solid #e0e1e5;
  background: transparent;
  padding: 7px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.select-custom span {
  font-size: 12px;
  padding-right: 10px;
}

.select-custom .select-selected {
  font-weight: 500;
  color: #333;
}

.select-custom img {
  width: 16px;
  height: 16px;
}

.select-custom-content {
  position: absolute;
  top: calc(100% + 5px);
  width: 150px;
  border: 1px solid #EAECF0;
  background: #fff;
  padding: 5px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 99999;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.select-custom-content.align-left {
  left: 0;
}

.select-custom-content.align-right {
  right: 0;
}

.select-custom-item {
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  border-radius: 8px;
}

.select-custom-item:hover {
  background-color: #F5F7FA;
}

.select-custom-item.selected {
  background-color: #F5F7FA;
  font-weight: 500;
}

.no-text-select {
  user-select: none;
}
</style>
